import React, { useState } from 'react';
import CollectionKeys from 'hooks/molecules/collection-keys';
import { makeStyles } from '@material-ui/styles';
import LabImportCSV from 'components/business/lab/LabImportCSV';
import LabCSVUploadPreview from 'components/business/lab/LabCSVUploadPreview';
import { useItems } from 'hooks/atoms/items-hook';
import { FaBriefcaseMedical } from 'react-icons/fa';
import getTheme from 'theme/theme';
import CollectionItemHeader from '../../layout/CollectionItemHeader';
import LabFilesTable from './LabFilesTable';
import AppLoader from '../../basic/AppLoader';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: theme.spacing(0, 1),
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: theme.spacing(1),
    },
    demo: {
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      marginLeft: '5%',
      marginRight: '5%',
    },
  };
});

function LabFiles() {
  const classes = useStyles();
  const [ loading, setLoading ] = useState(false);
  const {
    itemsLoading: serialNumbersLoading,
    count: totalEntries,
  } = useItems(CollectionKeys.LAB_FILES);

  if (serialNumbersLoading || loading) {
    return <AppLoader />;
  }

  return (
    <div className={ classes.root }>
      <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(2) } }>
        <FaBriefcaseMedical
          style={ { color: getTheme().palette.secondary.dark, marginRight: getTheme().spacing(2) } }
          size={ 36 }
        />
        <CollectionItemHeader
          title='Lab CSV Files'
          subtitle={ `Entries: ${ totalEntries }` }
          actions={ (
            <>
            </>
          ) }
        />
      </div>
      <LabFilesTable />
      <LabImportCSV />
      <LabCSVUploadPreview setLoading={ setLoading } />
    </div>
  );
}

export default LabFiles;
